// TODO: This file was created by bulk-decaffeinate.
// Sanity-check the conversion and remove this comment.
import classnames from 'classnames'


import IconSVG from 'svg-inline-react'

import { captureExceptions } from 'utils/SentryHelpers'

import style from './style'
import AudienceOptionStyle from 'components/CampaignWizards/TargetingInputArea/AudienceOption/style'

const SegmentOptionRow = React.createClass({
  getCreatorName() {
    if (this.props.author) {
      return this.props.author.name || this.props.author.email
    } else {
      return ''
    }
  },

  getSegmentUserCount() {
    // TODO get user count for segment
    return 9999
  },

  renderCountSection() {
    const count = this.getSegmentUserCount()
    return (
      <div className="end-user-count">
        <div className="count-value">
          <IconSVG
            className="user-icon"
            src={require('!svg-inline?removeTags=true!images/icons/user-icon.svg')} />
          {count}
        </div>
        {count > 1 ? 'Users' : 'User'}
      </div>
    )
  },

  renderCampaignType() {
    const authorName = this.getCreatorName()
    if (this.props.segment.type === 'ID_LIST') {
      return [
        <div className="type-icon-wrapper static">
          <IconSVG
            className="type-icon"
            src={require('!svg-inline?removeTags=true!components/campaign/images/static-segment-icon.svg')} />
        </div>,
        authorName ?
          `static segment created by ${ authorName }`
         : undefined
      ]
    } else {
      return [
        <div className="type-icon-wrapper">
          <IconSVG
            className="type-icon"
            src={require('!svg-inline?removeTags=true!./dynamic-icon.svg')} />
        </div>,
        `dynamic segment created by ${ authorName }`
      ]
    }
  },

  render() {
    // TODO detemine if the campaign is temp
    const isTemp = false
    return (
      <div
        className={classnames(style['campaign-segment-option'], AudienceOptionStyle.AudienceOption)}>
        <div className="segment-name-and-type">
          <div className="dsg-Body">
            {this.props.segment.name}
          </div>
          <div
            className={classnames('type', this.props.segment.type, AudienceOptionStyle.AudienceOption_Label)}>
            {!isTemp ?
              this.renderCampaignType() : undefined}
          </div>
        </div>
      </div>
    )
  }
      // TODO render this when we have count
      // @renderCountSection()

})

Marty.createContainer(SegmentOptionRow, {
  listenTo: ['stores.UserStore'],

  fetch: {
    author() {
      return this.app.stores.UserStore.getOrFetchUser(this.props.segment.authorId)
    }
  },

  failed(errors) {
    captureExceptions(errors)
    return <div />
  }

})

export default SegmentOptionRow



// WEBPACK FOOTER //
// ./src/scripts/components/campaign/NewCampaign/SegmentOptionRow/index.js